import React from 'react'
import cx from 'classnames'

import Icon, { EIconId } from '../../../../components/icons'

const PromotionBarModal: React.FC<{ onCloseClick: () => void }> = (props) => {
  const [infoOpen, setInfoOpen] = React.useState(false)

  return (
    <div
      className="flex fixed w-full h-full inset-x-0 inset-y-0 z-30 justify-center items-center"
      style={{ backgroundColor: 'rgba(0,0,0,.3)' }}
      onClick={props.onCloseClick}
      data-testid="wrapper"
    >
      <div
        className="flex flex-col relative px-16 py-24 mx-16 bg-white uif-shadow sm:py-32 sm:px-48 sm:uif-max-w-560 md:px-48"
        onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
      >
        <Icon
          id={EIconId.CLOSE_IN_CIRCLE}
          className="w-32 cursor-pointer absolute right-0 top-0 mr-8 mt-8 sm:mr-16 sm:mt-16"
          onClick={props.onCloseClick}
        />
        <Icon id={EIconId.CHECKMARK_IN_CIRCLE} className="w-48 mb-32 mx-auto text-winning-green" />
        <p className="text-20 mb-8">Ihr Gutschein ist vorgemerkt</p>
        <p className="text-winning-green mb-16">
          Ihr 10% Gutschein mit Code OSTERN10 wird automatisch am Ende des Bestellvorgangs angewendet.
        </p>
        <div className="border-t border-b border-lightgrey-light mb-16">
          <div
            className="flex items-center py-16 cursor-pointer"
            onClick={() => setInfoOpen(!infoOpen)}
            data-testid="dialog-trigger"
          >
            <Icon id={EIconId.INFO} className="w-20 mr-8" />
            Bedingungen
            <Icon
              id={EIconId.ANGLE_DOWN}
              className={cx('w-20 ml-auto transition-transform duration-200', {
                'scale-100': !infoOpen,
                '-scale-100': infoOpen,
              })}
            />
          </div>
          <div className={cx({ block: infoOpen, hidden: !infoOpen })} data-testid="dialog-body">
            {/*<p className="mb-16 font-bold">Einlösebedingungen für Deutschland & Österreich:</p>*/}
            <p className="mb-16 text-14">
              Gutschein gilt vom 17.04.-19.04.2022 für Neu- und Bestandskunden in Deutschland und Österreich; nur gültig
              für den Kauf von Mode auf www.hse.com, telefonisch oder über die HSE App. Der Gutschein ist pro Person
              täglich nur einmal einlösbar. Der Rabatt wird nur auf Produkte aus der Kategorie Mode im Warenkorb
              angerechnet. Für alle anderen Produkte des Warenkorbes gilt der Rabatt nicht. Barauszahlung nicht möglich.
              Für alle vorangegangenen Bestellungen des gleichen Tages oder spätere Einkäufe am gleichen Tag gilt der
              Rabatt nicht. Der Gutschein ist nicht übertragbar, er kann nicht mit anderen Gutscheinen, Teilzahlung (nur
              für D), Rabatten, PayPal, Treue-Abos, Warteliste oder sonstigen Aktionen kombiniert werden und gilt mit
              einer Bestellung auch bei Teil- sowie Vollretouren als eingelöst. Der Gutschein gilt nicht für HSE
              Mitarbeiter. Sie können den Gutscheincode OSTERN10 einfach bei &quot;Bestellung abschließen&quot; unter
              &quot;Gutschein einlösen&quot; eingeben. Bei Bestellungen über die EASy-Hotline bitte nur den EASy-Code
              22114 verwenden.
            </p>
          </div>
        </div>
        <p className="mb-16">Jetzt Wunschprodukte auswählen und bestellen!</p>
        <a
          className="flex items-center justify-center h-48 w-full sm:w-auto px-48 text-white font-bold cursor-pointer bg-brand-orange"
          href="/dpl/p/categories/mode"
          data-testid="action-button"
        >
          Jetzt Mode shoppen
        </a>
      </div>
    </div>
  )
}

export default PromotionBarModal
